const scroll_to_anchor = () => {
    $(document).on('click', 'a[href^="#"]', function(e) {
        e.preventDefault();
        let windowWidth = $(window).width();
        let headerOffsetHeight = 0;

        if ( windowWidth >= 834 ) {
            headerOffsetHeight = $('.header').height();
        }

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - headerOffsetHeight
        }, 500);
    });
}

export default scroll_to_anchor;